export enum TraitTypes {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Date = 'Date',
}

export enum SourceTypes {
  JsClient = 'Candu',
  SegmentBackend = 'Segment',
  Amplitude = 'Amplitude',
  EventWebhook = 'API',
  Rudderstack = 'Rudderstack',
  API = 'Forms',
}

export const TraitEnglishNames = {
  [TraitTypes.String]: 'Text',
  [TraitTypes.Boolean]: 'True/False',
  [TraitTypes.Number]: 'Number',
  [TraitTypes.Date]: 'Date',
};

export interface TraitsWithTypes {
  name: string;
  value: number | string | boolean;
  traitType: keyof typeof TraitTypes;
  indexTraitType: keyof typeof TraitTypes;
}

export interface UserTraitsWithTypes {
  id: string;
  traits: TraitsWithTypes[];
}
